const ResourceCenter = ({
  width = '24',
  height = '24',
  className = '',
  title = '',
  stroke = '1.5',
  role = ''
}): React.ReactNode => {
  const hidden = title && title.length > 0 ? false : true;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      stroke="#000000"
      aria-hidden={`${hidden}`}
      role={role ? role : hidden ? 'graphics-document' : 'img'}
    >
      {!hidden && <title>{title}</title>}
      <path
        d="M17.3333 5.01583C18.7245 4.79227 20.1306 4.67518 21.5396 4.66561C21.6606 4.66375 21.7775 4.70975 21.8649 4.79361C21.9506 4.87667 21.9993 4.99071 22 5.11006V19.1261C21.9976 19.3705 21.8 19.5681 21.5556 19.5705C14.184 19.6621 12 21.9989 12 21.9989V7.09406C12 7.09406 9.81778 4.75983 2.46044 4.66561C2.33876 4.66328 2.22112 4.70931 2.13333 4.79361C2.04829 4.87697 2.00026 4.99097 2 5.11006V19.1261C2.00241 19.3705 2.19999 19.5681 2.44444 19.5705C9.816 19.6621 12 21.9989 12 21.9989"
        strokeWidth={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke="currentColor"
      />
      <path
        d="M12 21.5609C12.1404 20.4089 12.6507 19.3334 13.4542 18.496C14.4882 17.3807 15.8441 16.6154 17.3333 16.3067V2.43734C17.3306 2.29208 17.2542 2.15817 17.1307 2.08178C16.9997 1.99949 16.8395 1.97808 16.6916 2.02312C15.4443 2.38152 14.3226 3.08277 13.4542 4.04712C12.6511 4.88407 12.1408 5.95882 12 7.11023"
        strokeWidth={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke="currentColor"
      />
    </svg>
  );
};

export default ResourceCenter;
